import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Menubar } from "primereact/menubar";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useAuthHeader, useAuthUser, useSignOut } from "../../auth/AuthService";
import { Toast } from "primereact/toast";
import { retrieveStockSession } from "../../Services/StockSessionApiService";

export default function Header () {
    const {t, i18n} = useTranslation();
    const [cookies, setCookie] = useCookies(['lang']);
    const menu = useRef(null);
    const navigator = useNavigate();
    const signOut = useSignOut();
    const auth = useAuthUser();
    const location = useLocation();
    const toast = useRef(null);
    const authHeader = useAuthHeader();
    const path = window.location.pathname.split("/")[1];

    const logoutFunction = () => {
        if (signOut()) {
            navigator('/login', {state: {logout: true}});
        }
    }

    const items = [
        {
          template: <Link to="/market-summary" className="no-underline flex w-full justify-content-center px-p"><Button label={t("Current Market")} text className={ (path === '' && 'surface-700') + ' lg:text-white p-2 w-6 lg:w-full text-sm font-light'} /></Link>,
          className: 'justify-content-center'
        },
        {
          template: <Link to="/current-stock" className="no-underline flex w-full justify-content-center px-0"><Button label={t("Current Stock")} text className={ (path === 'current-stock' && 'surface-700') + ' lg:text-white p-2 w-6 lg:w-full text-sm font-light'} /></Link>,
          className: 'justify-content-center'
        },
        {
          template: <Link to="/disclosures" className="no-underline flex w-full justify-content-center px-0"><Button label={t("Disclosure & Notice")} text className={ (path === 'disclosures' && 'surface-700') + ' lg:text-white p-2 w-6 lg:w-full text-sm font-light'} /></Link>,
          className: 'justify-content-center'
        },
        {
          template: <Link to="/historical-price" className="no-underline flex w-full justify-content-center px-0"><Button label={t("Historical Price")} text className={ (path === 'historical-price' && 'surface-700') + ' lg:text-white p-2 w-6 lg:w-full text-sm font-light'} /></Link>,
          className: 'justify-content-center'
        },
        {
          template: <Link to="/historical-index" className="no-underline flex w-full justify-content-center px-0"><Button label={t("Historical Index")} text className={ (path === 'historical-index' && 'surface-700') + ' lg:text-white p-2 w-6 lg:w-full text-sm font-light'} /></Link>,
          className: 'justify-content-center'
        },
        {
          template: <Link to="/stock-info" className="no-underline flex w-full justify-content-center px-0"><Button label={t("Stock Info")} text className={ (path === 'stock-info' && 'surface-700') + ' lg:text-white p-2 w-6 lg:w-full text-sm font-light'} /></Link>,
          className: 'justify-content-center'
        }
    ];

    let topMenu = auth()?.role == 'secc' ? [] : items;
  
    const itemUser = [
        { 
            label: <span className="text-sm">{t('Preference')}</span>, 
            icon: 'pi pi-wrench' ,
            command: () => {
                navigator('/user/edit');
            }
        },
        { 
            label: <span className="text-sm">{t('Data and information usage policy')}</span>, 
            icon: 'pi pi-info-circle',
            command: () => {
                navigator('/disclaimer');
            }
        },
        { separator: true},
        { 
            label: <span className="text-sm">{t('Logout')}</span>, 
            icon: 'pi pi-sign-out',
            command: () => {
                logoutFunction()
            }
        },
    ];

    const changeLang = (e) => {
        let val = e.currentTarget.value;
        val =  val == 1 ? 'kh' : 'en';
        setCookie('lang', val);
    }

    const lastActive = () => {
        document.addEventListener("mousemove", () =>{ 
            localStorage.setItem('lastActvity', new Date())
        });
        document.addEventListener("click", () =>{ 
            localStorage.setItem('lastActvity', new Date())
        });
    }

    async function checkStockSession() {
        await retrieveStockSession(authHeader())
        .catch((error) => {
            if (error?.response?.status === 403) {
                logoutFunction();
            }
        })
    }

    useEffect(()=> {
        i18n.changeLanguage(cookies.lang ?? 'en');
    }, [cookies.lang])

    useEffect(() => {
        if (location?.state?.login) {
            window.history.replaceState({}, document.title)
            setTimeout(() => {toast.current.show({ severity: 'info', detail:  'Login successful!' , life: 3000 })}, 100);
        }
    }, [])

    useEffect(() => {
        checkStockSession();
        lastActive();
        const interval = setInterval(checkStockSession, 10000);

        const checkLastActive = setInterval(() => {
            let lastAcivity = localStorage.getItem('lastActvity')
            var diffMs = Math.abs(new Date(lastAcivity) - new Date()); // milliseconds between now & last activity
            var seconds = Math.floor((diffMs/1000));
            var minute = Math.floor((seconds/60));
            if(minute == 10){
              clearInterval(checkLastActive)
              logoutFunction()
            }
          
          },1000);

        return () => {
            clearInterval(interval);
            clearInterval(checkLastActive);
        }
    }, []);

    return (
        <>
            <div className='fixed top-0 w-full z-5 hidden-print'>
                <div className='bg-header shadow-3 w-full flex justify-content-center border-bottom-1'>
                    <div className='flex w-11 lg:w-10 align-items-center justify-content-center'>
                        <div className='flex-1'>
                            <Menubar 
                                className="border-none py-0"
                                style={{color: 'white'}}
                                model={topMenu} 
                                orientation="horizontal" 
                                start={<div className="flex text-white text-900 text-3xl font-bold mr-3">ICSX</div>} 
                                end={
                                <div className='flex gap-2 align-items-center justify-content-end'>
                                    <Button className="bg-bluegray-600 hover:bg-bluegray-400 border-bluegray-700 justify-content-center min-w-0" style={{padding: '0.15rem'}} alt="ភាសាខ្មែរ" value="1" onClick={changeLang}>
                                        <img alt="logo" src="/img/flag/kh.png" className="h-1rem"></img>
                                    </Button>
                                    <Button className="bg-bluegray-600 hover:bg-bluegray-400 border-bluegray-700 justify-content-center min-w-0 h-auto"style={{padding: '0.15rem'}} value="2" onClick={changeLang}>
                                        <img alt="logo" src="/img/flag/en.png" className="h-1rem"></img>
                                    </Button>
                                    <Button className="bg-screen ml-2 my-2 text-white"  onClick={(e) => menu.current.toggle(e)}>
                                        <i className="pi pi-user pr-2"></i>
                                        <span>{auth()?.userData?.username}</span>
                                    </Button>
                                    <Menu model={itemUser} popup ref={menu}/>
                                </div>} 
                                breakpoint="1420px" />
                        </div>
                    </div>
                </div>
            </div>
            <div className='h-4rem hidden-print'></div>
            <Toast ref={toast} />
        </>
    )
}